module.exports = __webpack_public_path__ + "static/front/img/late.58473f63.svg";